import { clsx } from 'clsx';
import Select, { Props, StylesConfig } from 'react-select';

import { FilterIcon } from '../../icons/main-block';
import cn from './styles.module.scss';

const styles: StylesConfig = {
    indicatorSeparator: styles => ({ ...styles, display: 'none' }),
    control: styles => ({
        ...styles,
        minHeight: 20,
        border: 'none',
        boxShadow: 'none',
        fontSize: 14,
        cursor: 'pointer',
        backgroundColor: 'transparent',
    }),
    singleValue: styles => ({ ...styles, overflow: 'inherit', textAlign: 'right' }),
    menu: styles => ({ ...styles, width: 126, borderRadius: 10, top: 25, right: 4, zIndex: 2 }),
    option: (styles, { isFocused }) => ({
        ...styles,
        backgroundColor: isFocused ? '#CBD5E1' : 'transparent',
        color: '#111827',
        fontSize: 14,
        cursor: 'pointer',
    }),
};

export const Filter = ({ options, onChange, classNames, ...props }: Props) => {
    return (
        <div className={cn.filterWrapper}>
            <Select
                components={{ DropdownIndicator: () => FilterIcon }}
                //defaultValue={options?.[0]}
                placeholder="Сортировать"
                options={options}
                styles={styles}
                isSearchable={false}
                onChange={onChange}
                classNames={{
                    menuList: () => clsx(cn.menuList, classNames?.menuList),
                    option: () => clsx(cn.option, classNames?.option),
                    placeholder: () => clsx(cn.placeholder, classNames?.placeholder),
                    ...classNames,
                }}
                {...props}
            />
        </div>
    );
};
